import { render, staticRenderFns } from "./no-faq.vue?vue&type=template&id=3b546284&"
import script from "./no-faq.vue?vue&type=script&lang=js&"
export * from "./no-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports